import React from 'react';

function Tags(){

	return <div>
		<h1>Fetching Page...</h1>
	</div>

}
export default Tags

